import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import PriceTierSection from './components/PriceTierSection';
import ProductList from './components/ProductList';
import Testimonials from './components/Testimonials';
import About from './components/About';
import Footer from './components/Footer';
import CartDrawer from './components/CartDrawer';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const schemaOrg = [
  {
    '@context': 'https://schema.org',
    '@type': 'Store',
    name: '鮮肉本舖',
    alternateName: 'Fresh Meat Market',
    url: SITE_URL,
    description:
      '鮮肉本舖提供頂級鮮肉嚴選直送服務，精選台灣在地及進口優質豬肉、牛肉、雞肉、羊肉，每日新鮮到貨，真空包裝保鮮，5000+滿意顧客信賴推薦。',
    priceRange: 'NT$300 - NT$5000+',
    currenciesAccepted: 'TWD',
    paymentAccepted: '銀行轉帳',
    hasOfferCatalog: {
      '@type': 'OfferCatalog',
      name: '鮮肉商品目錄',
      itemListElement: [
        { '@type': 'OfferCatalog', name: '單品系列', description: '豬肉、牛肉、雞肉、羊肉單品，NT$300起' },
        { '@type': 'OfferCatalog', name: '套餐系列', description: '家庭烤肉套餐、雙拼燒烤組，NT$1,000起' },
        { '@type': 'OfferCatalog', name: '高端套組', description: '伊比利豬、美國肋眼等頂級肉品，NT$5,000起' },
      ],
    },
    sameAs: [],
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '鮮肉本舖',
    url: SITE_URL,
    inLanguage: 'zh-TW',
    potentialAction: {
      '@type': 'SearchAction',
      target: `${SITE_URL}/#products?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  },
];

export default function HomePage() {
  const [cartOpen, setCartOpen] = useState(false);
  const [activeTier, setActiveTier] = useState<string>('all');

  useEffect(() => {
    const existingScripts = document.querySelectorAll('script[data-schema="home"]');
    existingScripts.forEach((s) => s.remove());

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.setAttribute('data-schema', 'home');
    script.textContent = JSON.stringify(schemaOrg);
    document.head.appendChild(script);

    return () => {
      script.remove();
    };
  }, []);

  const handleTierChange = (tier: string) => {
    setActiveTier(tier);
  };

  return (
    <div className="min-h-screen bg-white">
      <Hero onCartOpen={() => setCartOpen(true)} onTierChange={handleTierChange} />
      <PriceTierSection activeTier={activeTier} onTierChange={handleTierChange} />
      <ProductList activeTier={activeTier} onTierChange={handleTierChange} />
      <About />
      <Testimonials />
      <Footer />
      <CartDrawer isOpen={cartOpen} onClose={() => setCartOpen(false)} />
    </div>
  );
}
